export default "__VITE_ASSET__e710fef3__"